import { SubmissionError } from 'redux-form'
import getStripeErrorMessage from './getStripeErrorMessage'
import { TRAILER_CARE_BASIC_TO_PLUS_UPGRADE } from 'types'
import { PAYMENT_STEP_TYPE } from 'config'
import { PAYMENT_STAGE, logPaymentFailed } from 'uxcam-service'
import {
  apiValuesForMembershipUpgrade,
  apiValuesForTrailerCareUpgrade,
  apiValuesForPurchase,
} from 'utils'

const handlePaymentSubmit = async ({
  addTrailerCare,
  chargeMembershipUpgrade,
  onOpportunityGuid,
  opportunityGuid,
  payload,
  paymentStepType,
  processPurchase,
  selectedTrailerCareType,
}) => {
  switch (paymentStepType) {
    case PAYMENT_STEP_TYPE.NEW_MEMBERSHIP:
    case PAYMENT_STEP_TYPE.MEMBERSHIP_RENEWAL: {
      const purchasePayload = {
        ...apiValuesForPurchase(payload),
        ...(opportunityGuid && { opportunity_guid: opportunityGuid }),
      }

      try {
        return await processPurchase(purchasePayload)
      } catch (error) {
        const responseBody =
          error?.response?.data ?? error?.response ?? error?.body
        if (responseBody?.opportunity_guid && onOpportunityGuid) {
          onOpportunityGuid(responseBody.opportunity_guid)
        }
        logPaymentFailed(PAYMENT_STAGE.PURCHASE, error, {
          payment_step: paymentStepType,
        })
        throw new SubmissionError({
          _error: getStripeErrorMessage(error),
        })
      }
    }

    // Both upgrade branches rethrow as-is; their callers own the message.
    case PAYMENT_STEP_TYPE.MEMBERSHIP_UPGRADE:
      try {
        return await chargeMembershipUpgrade(
          apiValuesForMembershipUpgrade(payload),
        )
      } catch (error) {
        logPaymentFailed(PAYMENT_STAGE.MEMBERSHIP_UPGRADE, error, {
          payment_step: paymentStepType,
        })
        throw error
      }

    case PAYMENT_STEP_TYPE.TRAILER_CARE_UPGRADE: {
      const apiValues = apiValuesForTrailerCareUpgrade(payload)
      const isBasicToPlusUpgrade =
        selectedTrailerCareType === TRAILER_CARE_BASIC_TO_PLUS_UPGRADE

      try {
        return await (isBasicToPlusUpgrade
          ? chargeMembershipUpgrade(apiValues)
          : addTrailerCare(apiValues))
      } catch (error) {
        logPaymentFailed(PAYMENT_STAGE.TRAILER_CARE_UPGRADE, error, {
          payment_step: paymentStepType,
        })
        throw error
      }
    }
  }
}

export default handlePaymentSubmit
